import {
  BANK_DETAILS,
  PERSONAL_DETAILS,
  SUPERANNUATION,
  TAX_DETAILS,
  TFN_DECLARATION,
  WORK_RIGHTS_UK_FIELDS,
} from '@/core/field-names';
import t from '@/lib/i18next';
import { DOCUMENT_NAMES } from '@/core/field-names';

const errorMessageMap = {
  // Personal details
  [PERSONAL_DETAILS.EMAIL]: 'Email',
  [PERSONAL_DETAILS.MOBILE]: 'Mobile',
  [PERSONAL_DETAILS.PREFERRED_NAME]: 'Preferred name',
  [PERSONAL_DETAILS.GENDER]: 'Gender',
  [PERSONAL_DETAILS.DOB]: 'Date of birth',
  [PERSONAL_DETAILS.ADDRESS]: 'Address',
  [PERSONAL_DETAILS.EMERGENCY_CONTACT_NAME]: 'Emergency contact name',
  [PERSONAL_DETAILS.EMERGENCY_CONTACT_MOBILE]:
    'Emergency contact mobile number',
  [PERSONAL_DETAILS.EMERGENCY_CONTACT_RELATIONSHIP]:
    'Emergency contact relationship',

  // AU Bank details
  [BANK_DETAILS.ACCOUNT_NAME]: 'Account name',
  [BANK_DETAILS.BANK_NAME]: 'Bank name',
  [BANK_DETAILS.SORT_CODE]: 'Bank sort code',
  [BANK_DETAILS.BSB]: 'BSB number',
  [BANK_DETAILS.ACCOUNT_NUMBER]: 'Account number',

  // AU tax file declaration form.
  [TFN_DECLARATION.OPTION]: 'Tax File Number question',
  [TFN_DECLARATION.TFN]: 'Tax File Number',
  [TFN_DECLARATION.REASON]: 'Missing TFN reason',
  [TFN_DECLARATION.TITLE]: 'Person title',
  [TFN_DECLARATION.NAME]: 'Person name',
  [TFN_DECLARATION.PAY_BASIS]: 'Pay basis',
  [TFN_DECLARATION.RESIDENT_STATUS]: 'Residence status',
  [TFN_DECLARATION.TAX_FREE_THRESHOLD]: 'Tax free threshold',
  [TFN_DECLARATION.HELP_LOAN_OR_STUDENT_DEBT]: 'Help loan or Student Debt',
  [TFN_DECLARATION.DECLARATION]: 'TFN form declaration',

  // AU superannuation
  [SUPERANNUATION.OPTION]: 'Superfund question',
  [SUPERANNUATION.TYPE]: 'Superfund type',
  [SUPERANNUATION.NAME]: 'Person name',
  [SUPERANNUATION.TFN]: 'Tax File Number',
  [SUPERANNUATION.FUND_NAME]: 'Superfund name',
  [SUPERANNUATION.MEMBER_NUMBER]: 'Member number',
  [SUPERANNUATION.SELF_MANAGED]: 'Self managed superfund',
  [SUPERANNUATION.DECLARATION]: 'Superfund form declaration',

  // UK Tax details
  [TAX_DETAILS.NATIONAL_INSURANCE_NUMBER]: 'National insurance number',
  [TAX_DETAILS.REASON]: 'Tax details question',
  [TAX_DETAILS.STUDENT_LOAN]: 'Student loan',
  [TAX_DETAILS.LOAN_PLANS]: 'Loan plans',
  [TAX_DETAILS.P45]: 'P45 question',
  [TAX_DETAILS.P45_UPLOAD]: 'P45 upload',
  [TAX_DETAILS.DECLARATION]: 'Tax details form declaration',

  // UK Work rights
  [WORK_RIGHTS_UK_FIELDS.RESIDENCY]: 'Residential status',
  [WORK_RIGHTS_UK_FIELDS.SHARE_CODE]: 'Share code',
  [WORK_RIGHTS_UK_FIELDS.PASSPORT]: 'Passport upload',
  [WORK_RIGHTS_UK_FIELDS.BIRTH_CERTIFICATE]: 'Birth certificate upload',
  [WORK_RIGHTS_UK_FIELDS.SUPPORTING_DOCUMENTS]: 'Supporting document upload',
};

export default function mapErrorMessage(message) {
  // TODO: Remove this after validations are fixed
  if (message.startsWith('proto')) {
    return 'Invalid input';
  }
  const [documentName, fieldName, additionalProp] = message
    .split(':')[0]
    .split('.');

  let key = documentName + '.' + fieldName;

  if (documentName === DOCUMENT_NAMES.ADDITIONAL_QUESTIONS) {
    message = t('custom-questions:missing-response-error');
  }

  if (documentName === DOCUMENT_NAMES.TFN_DECLARATION) {
    if (additionalProp) {
      key = key + '.' + additionalProp;
    }
  }

  if (Object.keys(errorMessageMap).includes(key)) {
    let errorMessage =
      errorMessageMap[key] + message.slice(message.lastIndexOf(':') + 1);

    if (key === PERSONAL_DETAILS.ADDRESS) {
      errorMessage = t('personal-details-address:invalid-address-error');
    }

    if (key === TFN_DECLARATION.TAX_FREE_THRESHOLD) {
      errorMessage = t('tfn-declaration:invalid-tax-free-threshold');
    }

    return {
      fieldName: key,
      message: errorMessage,
    };
  }
  return {
    fieldName: '',
    message,
  };
}
